import React, { FunctionComponent } from 'react'
import { Box, SxStyleProp } from 'theme-ui'

import theme from '../../gatsby-plugin-theme-ui'
const { colors } = theme
interface ILogoBrandProps {
  /** Theme UI JSX pragma */
  sx?: SxStyleProp
}

export const LogoBrand: FunctionComponent<ILogoBrandProps> = ({ sx }) => {
  return (
    <Box sx={{ margin: '0 auto', ...sx }}>
      <svg version="1.0" x="0px" y="0px" viewBox="0 0 400 350" width="100%" height="100%">
        <path
          d="M386.2,29.8c-5.8-8.4-15-9.8-25.5-11.5c-3-0.5-5.3-0.9-7.4-1.3c-1.8-0.3-3.4-0.6-4.7-0.8c-16.7-2.6-23.3,6.4-31,16.7
			c-0.9,1.3-2,2.8-3.2,4.3c-2.7,3.5-5.2,7.1-7.7,10.7c-0.7-2.6-1.5-5.1-2.3-7.7c-5.6-19.8-9.6-34-31.3-37.4
			c-4.6-0.7-9.9-0.9-16.9-1.3c-7.8-0.4-14.2,2.2-18.9,7c-3.9-3.3-8.9-5.3-14.7-5.7C217,2.2,211.3,2,205.7,1.9
			c-2.3-0.1-4.5-0.1-6.8-0.2c-0.4,0-0.8,0-1.1,0c-6.9,0-13.9,2.4-18.8,8.2c-0.7-1-1.5-1.9-2.3-2.7c-2.9-2.9-7.9-6.3-16.2-6.3l0,0
			c-4,0-8.1,0.1-12.1,0.1c-5.3,0-10.8,0-16.3-0.1c-12.8,0-22,8.8-23,22l-0.1,0.8c0,0.2,0,0.5,0,0.7c-4.6-4.9-10.1-8.9-16.4-11.7
			C79.9,7.1,66.3,8.4,56.5,9.5c-3.3,0.3-6.7,0.8-10.4,1.4c-5.6,0.9-11.3,2.2-16.6,3.3l-5,1C8.1,18.6,1.8,32.6,4.3,44.8
			c4.1,20.7,8.1,41.4,12.1,62.1c3.8,19.6,7.6,39.3,11.5,58.8c1.8,9.1,5.2,15.3,10.7,18.7c-3.7,4.2-5.7,9.8-5.8,16.5
			c-0.2,15.9-0.6,32.1-1,49.2l-0.5,20.7c0,0.3,0,0.6,0,0.9l0.4,12.8c0.4,12.5,0.9,26.5,1.2,40.6c0.3,13.5,9.4,22.9,22.5,23.2
			c1.9,0.1,3.9,0.2,5.8,0.3c3.2,0.2,6.5,0.4,9.9,0.4c0.8,0,1.5,0,2.4,0c6.9-0.2,16.3-0.4,23.1-7.7c0.8-0.9,1.6-1.8,2.3-2.9
			c4.5,6.5,11.7,9.1,18,9.2c8.5,0.1,17.1,0.2,25.6,0.2h1.8c12.5,0,21.4-8.7,22.2-21.5c0-0.4,0.1-0.9,0.1-1.3
			c12.4,14.7,30,23.9,48.5,23.9c1.3,0,2.8,0,4.1-0.1c28.9-2.2,51.9-23.6,58.4-54.5c5.8-27.4,6.1-104.1,5.8-114
			c8.5,1.3,58.4,8.6,59,8.7c0.6,0.1,15.1,0.1,20.1-3.6c5.2-3.8,8.4-9.7,9.5-17.6c3.4-23.1,7-46.4,10.5-69.2
			c2.2-13.7,4.2-27.4,6.3-41.1C390.4,46.5,391.8,37.8,386.2,29.8z M150.3,325.3c-0.3,4.4-2,6.3-5.9,6.3c-9,0-18.1,0-27.2-0.1
			c-5-0.1-6.2-3.8-6.4-7.9c-0.2-5.4-0.2-11-0.3-16.4c-0.1-3.8-1.8-5.4-5.6-5.9c-17.5-2.4-19-1.2-18.3,16.6
			c0.4,13.3-0.5,14.6-13.3,15c-5.7,0.2-11.5-0.4-17.2-0.6c-4.6-0.1-6.6-2.5-6.7-7.3c-0.5-19.2-1.2-38.2-1.7-53.6
			c0.6-25.8,1.2-48,1.5-70c0.1-5.5,2.4-8,7.5-7.9c7.1,0.1,14.1,0.1,21.2,0.4c4.8,0.2,7.4,2.6,7.4,8.2c-0.1,18.9,0.1,37.8,0.3,56.7
			c0.1,8.5,0.9,9.5,9.2,9.3c20-0.4,16.7,2.8,16.8-17.1c0-15.9,0.2-31.9,0.2-47.8c0-6.5,2.5-10.2,9.2-10.5c7.7-0.2,15.5-0.7,23.2-1.2
			c1.1-0.1,2.2,0,3,0.3c-0.4,1.5-0.6,3.2-0.7,4.9l-0.1,0.8c-0.3,4.6-0.6,9.2-0.8,13.9c-1.4,30-1.8,57.4,6.6,85.1
			C151.4,305.9,150.9,315.5,150.3,325.3z M134.9,129.8c0.2-3.6,0-7.2-0.5-10.8c-1.1-8.3-4.1-16.1-8.6-23.3c-2.6-18.9-1.9-38-1-57.2
			c0.2-4.8,0.5-9.6,0.8-14.5c0.3-4.3,2.3-6.8,6.7-6.8c9.5,0.1,19,0.1,28.5,0c4.2,0,5.9,2,5.9,6.3c0,11.3,0,22.4,0,33.7
			c-0.1,0-0.1,0-0.2,0c0,10.1-0.7,20.3,0.2,30.2c0.6,6.4,2.7,13,5.6,18.7c3.4,6.3,10.1,5.2,12.4-1.8c1.8-5.7,2.6-12.1,2.9-18.2
			c1-19.5,1.8-38.9,2.2-58.5c0.1-6.8,2.2-9.8,8.6-9.6c7.7,0.3,15.5,0.3,23.2,0.8c4.8,0.4,7.6,3,8.4,7.6c-0.1,0.4-0.2,0.9-0.3,1.3
			c-0.9,4.2-1.8,8.5-2.6,12.9c-2.5,13.9-4.8,27.9-7.3,41.7c-3.5,20.3-7.1,40.5-10.7,60.8c-0.2,1.1-0.3,2.2-0.4,3.3
			c-7.6,7.2-17.1,11.6-27.8,12.3C162.6,160.3,144,148.4,134.9,129.8z M261.6,290.7c-5,23.7-22,40.1-43.6,41.6
			c-20.5,1.5-41.1-13.4-48.8-35.4c-0.3-1-0.6-2.1-1-3.1c1.2-33.5,1-64.5-0.7-94c-0.1-1.3-0.3-2.8-0.5-4.1l-0.1-0.9
			c-0.2-1.2-0.4-2.5-0.7-3.7c0.8-0.3,1.8-0.5,3.1-0.5c9.5,0.1,19,0.1,28.5,0c4.2,0,5.9,2.1,5.9,6.3c0,11.3,0,22.4,0,33.7
			c-0.1,0-0.1,0-0.2,0c0,10.1-0.7,20.3,0.2,30.2c0.6,6.4,2.7,13,5.6,18.7c3.4,6.3,10.1,5.2,12.4-1.8c1.8-5.7,2.6-12.1,2.9-18.2
			c1-19.5,1.8-38.9,2.2-58.5c0.1-6.8,2.2-9.8,8.6-9.6c7.7,0.3,15.5,0.3,23.2,0.8c5.6,0.4,8.4,3.8,8.7,9.9
			C268.7,232,267.8,261.5,261.6,290.7z M372.7,54.9c-5.5,36.8-11.4,73.5-16.8,110.3c-1,6.9-4,8.8-10.1,7.6
			c-4.3-0.9-8.8-1.1-13.1-1.8c-12-2.1-12-2.1-10.2-14.1c1.9-13.4,3.9-27,5.8-40.4c0.3-2.4,0.4-4.8,0.7-9
			c-13.3,15.1-25.3,28.8-38.5,43.8c-10.1-15.4-12.6-32.5-19.6-47.5c-0.8,0-1.5-0.1-2.4-0.1c-1.3,8.8-2.7,17.5-4.1,26.3
			c-1.2,7.6-2.7,15.2-3.8,22.9c-0.7,5.2-3.2,7.9-8.5,6.8c-7-1.3-13.8-2.7-20.8-4c-2.7-0.5-4.4-1.5-5.3-3.2
			c7.1-8.6,12.2-19.4,14.8-31.6c5.8-27.4,7.7-56.8,5.9-92.6c0-0.2,0-0.5-0.1-0.7c0.2-1,0.4-2,0.6-3.1c0.9-4.7,3.4-6.8,8.4-6.6
			c26,1.3,25.9,1.2,33.3,27c3.5,12.4,7.4,24.6,11.1,36.9c0.2,0.8,0.9,1.5,1.6,2.7c8.8-12.7,17-25.3,26-37.4
			c14-18.8,9.6-15.9,30.5-12.5C375.3,37.1,375.3,37.5,372.7,54.9z"
        />
        <path
          fill={colors.primary}
          d="M47.5,271c0.6-25.8,1.2-48,1.5-70c0.1-5.5,2.4-8,7.5-7.9c7.1,0.1,14.1,0.1,21.2,0.4
				c4.8,0.2,7.4,2.6,7.4,8.2c-0.1,18.9,0.1,37.8,0.3,56.7c0.1,8.5,0.9,9.5,9.2,9.3c20-0.4,16.7,2.8,16.8-17.1
				c0-15.9,0.2-31.9,0.2-47.8c0-6.5,2.5-10.2,9.2-10.5c7.7-0.2,15.5-0.7,23.2-1.2c4.1-0.3,6.1,1.8,6.7,5.8c0.2,1.3,0.5,2.7,0.5,4.1
				c2.5,41.4,1.7,82.8-0.9,124.2c-0.3,4.4-2,6.3-5.9,6.3c-9,0-18.1,0-27.2-0.1c-5-0.1-6.2-3.8-6.4-7.9c-0.2-5.4-0.2-11-0.3-16.4
				c-0.1-3.8-1.8-5.4-5.6-5.9c-17.5-2.4-19-1.2-18.3,16.6c0.4,13.3-0.5,14.6-13.3,15c-5.7,0.2-11.5-0.4-17.2-0.6
				c-4.6-0.1-6.6-2.5-6.7-7.3C48.7,305.6,48,286.4,47.5,271z"
        />
        <path
          fill={colors.primary}
          d="M203.5,230.8c0,10.1-0.7,20.3,0.2,30.2c0.6,6.4,2.7,13,5.6,18.7c3.4,6.3,10.1,5.2,12.4-1.8
				c1.8-5.7,2.6-12.1,2.9-18.2c1-19.5,1.8-38.9,2.2-58.5c0.1-6.8,2.2-9.8,8.6-9.6c7.7,0.3,15.5,0.3,23.2,0.8
				c5.6,0.4,8.4,3.8,8.7,9.9c1.4,29.7,0.6,59.1-5.6,88.4c-5,23.7-22,40.1-43.6,41.6c-20.5,1.5-41.1-13.4-48.8-35.4
				c-9.7-27.7-8.9-56.4-7.6-85.1c0.2-4.8,0.5-9.6,0.8-14.5c0.3-4.3,2.3-6.8,6.7-6.8c9.5,0.1,19,0.1,28.5,0c4.2,0,5.9,2.1,5.9,6.3
				c0,11.3,0,22.4,0,33.7C203.6,230.8,203.6,230.8,203.5,230.8z"
        />

        <polyline points="198.7,25.4 198.7,25.4 198.7,25.4" />
        <polyline points="197,26.8 197,26.8 197,26.8" />
        <path
          fill={colors.secondary}
          d="M117.8,118.5c-0.1-0.3-0.1-0.6-0.2-0.9c-0.1-0.5-0.3-1.1-0.4-1.6c-0.1-0.4-0.2-0.8-0.3-1.1
				c-0.1-0.4-0.3-0.9-0.4-1.3c-0.2-0.4-0.3-0.8-0.5-1.3c-0.1-0.4-1.8-5.8-5.6-9.5c-3.8-3.6-9.2-6-13.4-7.6
				c-13-4.5-23.6-0.2-28.5,2.6c-3.1,1.7-7,0.6-8.7-2.5c-1.7-3.1-0.6-7,2.5-8.7c3.1-1.7,6.3-3.2,9.5-4.2c-4.6-5-11.9-7.7-18.6-6.6
				c-2.6,0.5-5.1-1.2-5.5-3.9c-0.5-2.7,1.2-5.1,3.9-5.5c11.8-2,24.5,3.8,30.6,13.9c4.8-0.4,9.7,0,14.5,1.2l0,0c0.3-0.3,0.7-0.7,1-1
				l0.1-0.1c0.5-0.6,1-1.1,1.5-1.7c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.3,0.4-0.5,0.6-0.8c0.3-0.3,0.5-0.7,0.7-1.1
				c0.2-0.2,0.3-0.5,0.5-0.7c0.3-0.5,0.6-0.9,0.8-1.4c0.1-0.2,0.2-0.4,0.3-0.5c0.3-0.6,0.6-1.2,0.9-1.9C107.4,63,107,53,103,44.7
				c-3.5-7.4-9.6-13.4-17.1-16.8c-8.7-3.9-18.8-3-28-2.1c-10.1,1-20.3,3.4-30.3,5.4c-7.9,1.6-8.1,7.4-7.5,10.5
				c8,40.3,15.7,80.7,23.6,120.9c1.7,8.7,2.9,9.5,11.7,8.1c3-0.5,5.8-1,8.8-1.5c8.4-1,16.6-3.1,24.7-5.6c9.2-3,18.3-7.5,23.8-15.9
				c5-7.8,6.7-17.1,5.4-26.2C118.1,120.3,117.9,119.4,117.8,118.5z"
        />
        <path
          fill={colors.secondary}
          d="M328.8,107.4c-13.3,15.1-25.3,28.8-38.5,43.8c-10.1-15.4-12.6-32.5-19.6-47.5c-0.8,0-1.5-0.1-2.4-0.1
				c-1.3,8.8-2.7,17.5-4.1,26.3c-1.2,7.6-2.7,15.2-3.8,22.9c-0.7,5.2-3.2,7.9-8.5,6.8c-7-1.3-13.8-2.7-20.8-4
				c-5.1-0.9-6.8-3.8-5.8-9.2c6-34.1,11.9-68.4,17.9-102.6c1.1-6.5,2.7-12.9,3.9-19.4c0.9-4.7,3.4-6.8,8.4-6.6
				c26,1.3,25.9,1.2,33.3,27c3.5,12.4,7.4,24.6,11.1,36.9c0.2,0.8,0.9,1.5,1.6,2.7c8.8-12.7,17-25.3,26-37.4
				c14-18.8,9.6-15.9,30.5-12.5c17.1,2.7,17.1,3.1,14.6,20.5c-5.5,36.8-11.4,73.5-16.8,110.3c-1,6.9-4,8.8-10.1,7.6
				c-4.3-0.9-8.8-1.1-13.1-1.8c-12-2.1-12-2.1-10.2-14.1c1.9-13.4,3.9-27,5.8-40.4C328.4,114,328.5,111.6,328.8,107.4z"
        />
        <path
          fill={colors.secondary}
          d="M166.6,57.4c0,10.1-0.7,20.3,0.2,30.2c0.6,6.4,2.7,13,5.6,18.7c3.4,6.3,10.1,5.2,12.4-1.8
					c1.8-5.7,2.6-12.1,2.9-18.2c1-19.5,1.8-39,2.2-58.5c0.1-6.8,2.2-9.8,8.6-9.6c7.7,0.3,15.5,0.3,23.2,0.8c5.6,0.4,8.4,3.8,8.7,9.9
					c1.4,29.7,0.6,59.1-5.6,88.4c-5,23.7-22,40.1-43.6,41.6c-20.5,1.5-41.1-13.4-48.8-35.4c-9.7-27.7-8.9-56.4-7.6-85.1
					c0.2-4.8,0.5-9.6,0.8-14.5c0.3-4.3,2.3-6.8,6.7-6.8c9.5,0.1,19,0.1,28.5,0c4.2,0,5.9,2.1,5.9,6.3c0,11.3,0,22.4,0,33.7
					C166.7,57.4,166.6,57.4,166.6,57.4z"
        />
        <polyline points="286.9,33.6 286.9,33.6 286.9,33.6 		" />
        <path
          fill={colors.white}
          d="M155.5,51.9h-0.1c-2.7-0.1-4.7-2.3-4.7-4.9l0.5-22.2c0.1-2.7,2.3-4.8,4.9-4.7c2.7,0.1,4.7,2.3,4.7,4.9
				l-0.5,22.3C160.2,49.8,158.1,51.9,155.5,51.9z"
        />
        <polyline points="28,33.6 28,33.6 28,33.6" />
        <path d="M94.5,145.9c-6,1-4.5,10.5,1.5,9.4C102.2,154.3,100.7,144.9,94.5,145.9z" />
        <path d="M96.5,134.2c-4.6,0.8-3.5,8,1.2,7.3C102.3,140.7,101.1,133.4,96.5,134.2z" />
        <path d="M104.8,140.8c-5,0.8-3.7,8.6,1.3,7.8C111,147.6,109.7,139.9,104.8,140.8z" />
        <path
          fill={colors.white}
          d="M74.3,230.1h-0.1c-2.7-0.1-4.7-2.3-4.7-4.9L70,203c0.1-2.7,2.3-4.8,4.9-4.7c2.7,0.1,4.7,2.3,4.7,4.9
					l-0.5,22.2C79,228.1,76.9,230.1,74.3,230.1z"
        />
        <path
          fill={colors.white}
          d="M363.9,40.1c-2.7-0.3-5,1.4-5.4,4.1l-5.2,38.3c-0.3,2.7,1.4,5,4.1,5.4c0.2,0,0.4,0,0.6,0
					c2.4,0,4.4-1.7,4.7-4.2l5.2-38.3C368.4,42.9,366.5,40.4,363.9,40.1z"
        />
        <path fill={colors.white} d="M356.8,91.5c-6.8-1-8.5,9.5-1.6,10.6C361.9,103.1,363.6,92.5,356.8,91.5z" />
        <path
          fill={colors.white}
          d="M219.2,74.6C219.2,74.6,219.3,74.6,219.2,74.6c2.7,0.2,5-1.8,5.1-4.6c0.9-14.5,0.8-28.9-0.3-43.4
					c-0.2-2.8-2.6-4.8-5.2-4.5h-0.1c-2.6,0.3-4.5,2.7-4.3,5.2c1,14,1.1,28.1,0.2,42C214.6,72,216.6,74.3,219.2,74.6z"
        />
        <path fill={colors.white} d="M219.5,78.4c-6.7-0.4-7.7,9.9-1,10.7C225.3,89.9,226.3,79,219.5,78.4z" />
        <path
          fill={colors.white}
          d="M139.7,247.9C139.7,247.9,139.8,247.9,139.7,247.9c2.7,0.2,5-1.8,5.1-4.6c0.9-14.5,0.8-28.9-0.3-43.4
					c-0.2-2.8-2.6-4.8-5.2-4.5h-0.1c-2.6,0.3-4.5,2.7-4.3,5.2c1,14,1.1,28.1,0.2,42C135.1,245.3,137,247.6,139.7,247.9z"
        />
        <path fill={colors.white} d="M139.9,251.8c-6.7-0.4-7.7,9.9-1,10.7C145.8,263.3,146.8,252.2,139.9,251.8z" />
        <path
          fill={colors.white}
          d="M192.3,226h-0.1c-2.7-0.1-4.7-2.3-4.7-4.9l0.5-22.2c0.1-2.7,2.3-4.8,4.9-4.7c2.7,0.1,4.7,2.3,4.7,4.9
					l-0.5,22.2C197,224,194.9,226,192.3,226z"
        />
        <path
          fill={colors.white}
          d="M277.5,53.8c-2.2,0.1-4.2-1.2-4.9-3.5L266.7,30c-0.7-2.6,0.7-5.2,3.3-5.9s5.2,0.7,5.9,3.3l5.8,20.4
					c0.7,2.6-0.7,5.2-3.3,5.9C278.2,53.7,277.8,53.8,277.5,53.8z"
        />
        <path
          fill={colors.white}
          d="M94.7,56.8c-1.9,0-3.8-1.1-4.5-3.1c-7.5-19.6-26-14.3-26.9-14.1c-2.6,0.7-5.2-0.7-5.9-3.3
						c-0.7-2.6,0.7-5.2,3.3-5.9c0.3-0.1,27.9-7.9,38.5,19.9c0.9,2.5-0.3,5.2-2.8,6.3C95.8,56.7,95.3,56.8,94.7,56.8z"
        />
        <path fill={colors.white} d="M48.7,32.9c-6.5,1-4.8,11.1,1.6,10C56.8,41.9,55.1,31.8,48.7,32.9z" />
        <path
          fill={colors.white}
          d="M254.8,248.9C254.8,248.9,254.9,248.9,254.8,248.9c2.7,0.2,5-1.8,5.1-4.6c0.9-14.5,0.8-28.9-0.3-43.4
					c-0.2-2.8-2.6-4.8-5.2-4.5h-0.1c-2.6,0.3-4.5,2.7-4.3,5.2c1,14,1.1,28.1,0.2,42C250.2,246.3,252.1,248.6,254.8,248.9z"
        />
        <path fill={colors.white} d="M255,252.8c-6.7-0.4-7.7,9.9-1,10.7C260.9,264.3,261.9,253.2,255,252.8z" />
        <polyline points="289.9,194.9 289.9,194.9 289.9,194.9 		" />
        <path
          fill={colors.secondary}
          d="M352.9,242.4c-0.3,0.3-0.5,0.5-0.8,0.8c13.7,7.2,25.1,19.4,27.3,35.3c1.2,9.1-0.4,18.6-5.4,26.2
			c-5.4,8.4-14.6,13-23.8,15.9c-8.1,2.6-16.3,4.7-24.7,5.6c-3,0.5-5.8,1-8.8,1.5c-8.8,1.4-9.9,0.7-11.7-8.1
			c-8-40.3-15.7-80.7-23.6-120.9c-0.6-3.1-0.4-8.8,7.5-10.5c10-2.1,20.2-4.4,30.3-5.4c9.2-0.9,19.3-1.8,28,2.1
			c7.5,3.4,13.5,9.3,17.1,16.8c4,8.3,4.4,18.3,0.5,26.8C362.1,234.7,358,239.1,352.9,242.4z"
        />
        <path d="M355.8,303.1c-6,1-4.5,10.5,1.5,9.4C363.4,311.5,361.8,302.1,355.8,303.1z" />
        <path d="M357.6,291.4c-4.6,0.8-3.5,8,1.2,7.3C363.5,297.9,362.4,290.6,357.6,291.4z" />
        <path d="M365.9,298c-5,0.8-3.7,8.6,1.3,7.8C372.2,304.9,371,297.2,365.9,298z" />
        <path
          fill={colors.white}
          d="M355.9,214.1c-1.9,0-3.8-1.1-4.5-3.1c-7.5-19.6-26-14.3-26.9-14.1c-2.6,0.7-5.2-0.7-5.9-3.3
					s0.7-5.2,3.3-5.9c0.3-0.1,27.9-7.9,38.5,19.9c0.9,2.5-0.3,5.2-2.8,6.3C357.1,213.9,356.5,214.1,355.9,214.1z"
        />
        <path fill={colors.white} d="M309.9,190.2c-6.5,1-4.8,11.1,1.6,10C318,199.1,316.3,189,309.9,190.2z" />
        <path
          d="M395.7,276.3c-1.8-13.3-8.4-25.6-18.8-35.4c1-1.7,2-3.6,2.9-5.4c5.7-12.6,5.5-27.8-0.6-40.6c-5.2-11-14.1-19.8-25.1-24.6
			c-12.8-5.7-26.4-4.4-36.3-3.4c-3.3,0.3-6.7,0.8-10.4,1.4c-5.6,0.9-11.3,2.2-16.6,3.3l-5,1c-16.4,3.4-22.7,17.4-20.2,29.6
			c4.1,20.7,8.1,41.4,12.1,62.1c3.8,19.6,7.6,39.3,11.5,58.8c3.5,17.4,12.8,24,30.3,21c2.9-0.5,5.6-0.9,8.5-1.4
			c1.6-0.2,3.3-0.4,4.9-0.7c6.9-1.1,13.9-2.9,22.3-5.5c15.2-4.8,25.8-12.2,32.6-22.7C394.6,302.9,397.5,289.6,395.7,276.3z
			 M374,304.8c-5.4,8.4-14.6,13-23.8,15.9c-8.1,2.6-16.3,4.7-24.7,5.6c-3,0.5-5.8,1-8.8,1.5c-8.8,1.4-9.9,0.7-11.7-8.1
			c-8-40.3-15.7-80.7-23.6-120.9c-0.6-3.1-0.4-8.8,7.5-10.5c10-2.1,20.2-4.4,30.3-5.4c9.2-0.9,19.3-1.8,28,2.1
			c7.5,3.4,13.5,9.3,17.1,16.8c4,8.3,4.4,18.3,0.5,26.8c-1.8,4.1-4.3,7.4-7.2,10.1c-4.8-1.1-9.6-1.5-14.5-1.2
			c-6.3-10.1-18.9-16-30.6-13.9c-2.7,0.5-4.4,3-3.9,5.5c0.5,2.6,3,4.4,5.5,3.9c6.7-1.2,13.9,1.5,18.6,6.6c-3.3,1-6.5,2.4-9.5,4.2
			c-3.1,1.7-4.1,5.6-2.5,8.7c1.7,3.1,5.6,4.1,8.7,2.5c6.5-3.7,23.4-10.5,41.9,5c0.2,0.2,0.5,0.4,0.8,0.5c3.7,5.3,6.3,11.4,7.2,18.1
			C380.7,287.5,379.1,297,374,304.8z"
        />
      </svg>
    </Box>
  )
}
